import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { AnnouncementBar } from "./AnnouncementBar";
import { useAnnouncement } from "../lib/announcement";

export const Layout = () => {
  const location = useLocation();
  const lenisRef = useRef(null);
  const { active } = useAnnouncement();

  useEffect(() => {
    if (new URLSearchParams(window.location.search).has("nolenis")) return;
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="App grain bg-ink text-white min-h-screen flex flex-col">
      <AnnouncementBar />
      <Header />
      <main className="flex-1" style={{ paddingTop: active ? 36 : 0 }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
